import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const updateHeaderSlice = createSlice({
  name: 'updateHeader',
  initialState: {
  },
  reducers: {
    updateSelectedSums: (state, action) => {
      const { selectedMovementsSum, totalMovementsSum, selectedNetWeightSum, totalNetWeightSum, selectedVolumeSum, 
        totalVolumeSum, selectedLLSum, totalLLSum, selectedWeightSum, totalWeightSum, selectedQuantitySum, totalQuantitySum, measurementField } = action.payload;
      return {
        ...state, selectedMovementsSum, totalMovementsSum, selectedNetWeightSum, totalNetWeightSum, selectedVolumeSum, 
          totalVolumeSum, selectedLLSum, totalLLSum, selectedWeightSum, totalWeightSum, selectedQuantitySum, totalQuantitySum, measurementField
      };
    },
  }
})
// case under reducers becomes an action 
export const { updateSelectedSums } = updateHeaderSlice.actions
export default updateHeaderSlice.reducer 
